import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalSearchResult } from '@shared/index';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  constructor(private http: HttpClient) { }

  public async search(query: string, limit: number = 5): Promise<GlobalSearchResult> {
    return await firstValueFrom(
      this.http.get<GlobalSearchResult>('/api/search', {
        params: { q: query, limit: limit.toString() }
      })
    );
  }
}
